import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./scss/index.scss";
import axios from "axios";
import React, { useContext, useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { animated, useSpring } from "react-spring";
import { useNavigate } from "react-router-dom";
import ReactSVG from "react-svg"; // import { generateCategoryUrl } from "../../../core/utils";

import { Money } from "@components/containers";
import { commonMessages } from "@temp/intl";
import { useAuth, useCart, useCheckout, useCurrentTradeDetails, useVouchersAvailableToUser } from "@saleor/sdk";
import { CurrentTradeDetailsContext } from "@temp/contexts";
import * as S from "./styles";
import { AlertCheckoutErrors, AlertDeleteCheckout, AlertVouchersAvailableToUser, Button, Offline, OfflinePlaceholder, Online, Overlay } from "../..";
import { AlertCheckoutValue } from "../../AlertCheckoutValue";
import { AlertCheckoutAmount } from "../../AlertCheckoutAmount";
import { AlertBusinessOpening } from "../../AlertBusinessOpening";
import Loader from "../../Loader";
import Empty from "./Empty";
import ProductList from "./ProductList";
import cartImg from "../../../images/cart.svg";
import emtpyCartImg from "../../../images/emptyCart.svg";
import goBackImg from "../../../images/goback.svg";
import { apiUrl } from "../../../constants";

var Cart = function Cart(_ref) {
  var _dataCurrentTrade$cur, _dataCurrentTrade$cur2, _shippingMethods$, _shippingMethods$$pri, _shippingMethods$2, _shippingMethods$2$pr, _dataAttention$curren, _dataAttention$curren2, _user$currentTrade2, _dataAttention$curren3, _dataAttention$curren4, _dataAttention$curren5, _dataAttention$curren6;

  var overlay = _ref.overlay;

  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      loadingMutation = _React$useState2[0],
      setLoadingMutation = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      showAlert = _React$useState4[0],
      setShowAlert = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      showAlertAmount = _React$useState6[0],
      setShowAlertAmount = _React$useState6[1];

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      showAlertOpening = _React$useState8[0],
      setShowAlertOpening = _React$useState8[1];

  var _React$useState9 = React.useState(false),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      showAlertDeleteCheckout = _React$useState10[0],
      setShowAlertDeleteCheckout = _React$useState10[1];

  var _React$useState11 = React.useState(false),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      flagLoading = _React$useState12[0],
      setFlagLoading = _React$useState12[1];

  var _React$useState13 = React.useState(false),
      _React$useState14 = _slicedToArray(_React$useState13, 2),
      showVouchersList = _React$useState14[0],
      setShowVouchersList = _React$useState14[1];

  var _React$useState15 = React.useState(false),
      _React$useState16 = _slicedToArray(_React$useState15, 2),
      loading = _React$useState16[0],
      setLoading = _React$useState16[1];

  var _React$useState17 = React.useState(""),
      _React$useState18 = _slicedToArray(_React$useState17, 2),
      viewHour = _React$useState18[0],
      setViewHour = _React$useState18[1];

  var _React$useState19 = React.useState([]),
      _React$useState20 = _slicedToArray(_React$useState19, 2),
      errors = _React$useState20[0],
      setErrors = _React$useState20[1];

  var navigate = useNavigate();
  var intl = useIntl();

  var _useAuth = useAuth(),
      user = _useAuth.user;

  var _useCheckout = useCheckout(),
      checkout = _useCheckout.checkout,
      addPromoCode = _useCheckout.addPromoCode,
      promoCodeDiscount = _useCheckout.promoCodeDiscount;

  var _useCart = useCart(),
      loaded = _useCart.loaded,
      items = _useCart.items,
      removeItem = _useCart.removeItem,
      deleteCheckout = _useCart.deleteCheckout,
      subtotalPrice = _useCart.subtotalPrice,
      discount = _useCart.discount,
      totalPrice = _useCart.totalPrice,
      updateItem = _useCart.updateItem;

  var _React$useState21 = React.useState(!!(promoCodeDiscount === null || promoCodeDiscount === void 0 ? void 0 : promoCodeDiscount.voucherCode) || !(checkout === null || checkout === void 0 ? void 0 : checkout.id)),
      _React$useState22 = _slicedToArray(_React$useState21, 2),
      loadedCart = _React$useState22[0],
      setLoadedCart = _React$useState22[1];

  var _useVouchersAvailable = useVouchersAvailableToUser({
    fetchPolicy: "network-only",
    skip: !!(promoCodeDiscount === null || promoCodeDiscount === void 0 ? void 0 : promoCodeDiscount.voucherCode) || !(checkout === null || checkout === void 0 ? void 0 : checkout.id)
  }),
      vouchersData = _useVouchersAvailable.data,
      vouchersLoading = _useVouchersAvailable.loading;

  var _useContext = useContext(CurrentTradeDetailsContext),
      dataCurrentTrade = _useContext.data;

  var shippingMethods = (dataCurrentTrade === null || dataCurrentTrade === void 0 ? void 0 : (_dataCurrentTrade$cur = dataCurrentTrade.currentShippingMethods) === null || _dataCurrentTrade$cur === void 0 ? void 0 : _dataCurrentTrade$cur.length) && (dataCurrentTrade === null || dataCurrentTrade === void 0 ? void 0 : (_dataCurrentTrade$cur2 = dataCurrentTrade.currentShippingMethods) === null || _dataCurrentTrade$cur2 === void 0 ? void 0 : _dataCurrentTrade$cur2.length) > 0 ? dataCurrentTrade === null || dataCurrentTrade === void 0 ? void 0 : dataCurrentTrade.currentShippingMethods : [];

  var _React$useState23 = React.useState(""),
      _React$useState24 = _slicedToArray(_React$useState23, 2),
      inputPromoValue = _React$useState24[0],
      setInputPromoValue = _React$useState24[1];

  var _React$useState25 = React.useState(false),
      _React$useState26 = _slicedToArray(_React$useState25, 2),
      loadingPromoCode = _React$useState26[0],
      setLoadingPromoCode = _React$useState26[1];

  var _React$useState27 = React.useState([]),
      _React$useState28 = _slicedToArray(_React$useState27, 2),
      promoCodeErrors = _React$useState28[0],
      setPromoCodeErrors = _React$useState28[1];

  var _React$useState29 = React.useState(false),
      _React$useState30 = _slicedToArray(_React$useState29, 2),
      hasSuccessVoucher = _React$useState30[0],
      setHasSuccessVoucher = _React$useState30[1];

  var _React$useState31 = React.useState({
    amount: (_shippingMethods$ = shippingMethods[0]) === null || _shippingMethods$ === void 0 ? void 0 : (_shippingMethods$$pri = _shippingMethods$.price) === null || _shippingMethods$$pri === void 0 ? void 0 : _shippingMethods$$pri.amount,
    currency: (_shippingMethods$2 = shippingMethods[0]) === null || _shippingMethods$2 === void 0 ? void 0 : (_shippingMethods$2$pr = _shippingMethods$2.price) === null || _shippingMethods$2$pr === void 0 ? void 0 : _shippingMethods$2$pr.currency
  }),
      _React$useState32 = _slicedToArray(_React$useState31, 2),
      priceShipping = _React$useState32[0],
      setPriceShipping = _React$useState32[1];

  var handleAddPromoCode = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(promoCode, notSubmit) {
      var _yield$addPromoCode, dataError, errors;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoadingPromoCode(true);
              _context.next = 3;
              return addPromoCode(promoCode);

            case 3:
              _yield$addPromoCode = _context.sent;
              dataError = _yield$addPromoCode.dataError;
              errors = dataError === null || dataError === void 0 ? void 0 : dataError.error;

              if (errors) {
                setHasSuccessVoucher(false);
                setPromoCodeErrors(errors);
              } else {
                setHasSuccessVoucher(true);
                setPromoCodeErrors([]);
              }

              setLoadingPromoCode(false);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleAddPromoCode(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  React.useEffect(function () {
    if (inputPromoValue) {
      handleAddPromoCode(inputPromoValue);
    }
  }, [inputPromoValue]);
  React.useEffect(function () {
    if (totalPrice && shippingMethods && shippingMethods.length > 1) {
      shippingMethods.forEach(function (shippingMethod) {
        if ((shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.minimumOrderPrice) && (shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.maximumOrderPrice) && (shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.minimumOrderPrice.amount) <= totalPrice.net.amount && totalPrice.net.amount <= (shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.maximumOrderPrice.amount) || (shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.minimumOrderPrice) && !(shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.maximumOrderPrice) && (shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.minimumOrderPrice.amount) <= totalPrice.net.amount) {
          var _shippingMethod$price, _shippingMethod$price2;

          setPriceShipping({
            amount: shippingMethod === null || shippingMethod === void 0 ? void 0 : (_shippingMethod$price = shippingMethod.price) === null || _shippingMethod$price === void 0 ? void 0 : _shippingMethod$price.amount,
            currency: shippingMethod === null || shippingMethod === void 0 ? void 0 : (_shippingMethod$price2 = shippingMethod.price) === null || _shippingMethod$price2 === void 0 ? void 0 : _shippingMethod$price2.currency
          });
        }
      });
    } else {
      var _shippingMethods$3, _shippingMethods$4;

      setPriceShipping({
        amount: (_shippingMethods$3 = shippingMethods[0]) === null || _shippingMethods$3 === void 0 ? void 0 : _shippingMethods$3.price.amount,
        currency: (_shippingMethods$4 = shippingMethods[0]) === null || _shippingMethods$4 === void 0 ? void 0 : _shippingMethods$4.price.currency
      });
    }
  }, [totalPrice]);
  React.useEffect(function () {
    var _vouchersData$voucher, _vouchersData$voucher2;

    if (!loadedCart && (checkout === null || checkout === void 0 ? void 0 : checkout.id) && !vouchersLoading && (items === null || items === void 0 ? void 0 : items.length) > 0 && (vouchersData === null || vouchersData === void 0 ? void 0 : vouchersData.vouchersAvailableToUser) && (vouchersData === null || vouchersData === void 0 ? void 0 : (_vouchersData$voucher = vouchersData.vouchersAvailableToUser) === null || _vouchersData$voucher === void 0 ? void 0 : _vouchersData$voucher.length) > 0 && !(promoCodeDiscount === null || promoCodeDiscount === void 0 ? void 0 : promoCodeDiscount.voucherCode) && !showVouchersList) {
      setLoadedCart(true);
      setShowVouchersList(true);
    } else if (!vouchersLoading && (vouchersData === null || vouchersData === void 0 ? void 0 : vouchersData.vouchersAvailableToUser) && !(promoCodeDiscount === null || promoCodeDiscount === void 0 ? void 0 : promoCodeDiscount.voucherCode) && ((vouchersData === null || vouchersData === void 0 ? void 0 : (_vouchersData$voucher2 = vouchersData.vouchersAvailableToUser) === null || _vouchersData$voucher2 === void 0 ? void 0 : _vouchersData$voucher2.length) === 0 || (items === null || items === void 0 ? void 0 : items.length) === 0 || !(checkout === null || checkout === void 0 ? void 0 : checkout.id)) && showVouchersList) {
      setShowVouchersList(false);
    }

    return function () {};
  }, [checkout === null || checkout === void 0 ? void 0 : checkout.id, location.pathname, vouchersLoading, items === null || items === void 0 ? void 0 : items.length]);
  var scaleButton = useSpring({
    config: {
      friction: 40,
      mass: 5,
      tension: 350
    },
    from: {
      scale: 1.1
    },
    loop: true,
    to: {
      scale: 1
    }
  });

  var _useCurrentTradeDetai = useCurrentTradeDetails({
    change: false
  }, {
    fetchPolicy: "network-only",
    skip: !(user === null || user === void 0 ? void 0 : user.id)
  }),
      dataAttention = _useCurrentTradeDetai.data;

  var hour = dataAttention === null || dataAttention === void 0 ? void 0 : (_dataAttention$curren = dataAttention.currentTrade) === null || _dataAttention$curren === void 0 ? void 0 : (_dataAttention$curren2 = _dataAttention$curren.nextAttentionTime) === null || _dataAttention$curren2 === void 0 ? void 0 : _dataAttention$curren2.fromHour;
  var quantityItemsAlert = items === null || items === void 0 ? void 0 : items.map(function (item) {
    return item.quantity;
  });
  var quantityAlert = quantityItemsAlert === null || quantityItemsAlert === void 0 ? void 0 : quantityItemsAlert.reduce(function (previousValue, currentValue) {
    return currentValue + previousValue;
  }, 0);

  var refreshHasAttention = function refreshHasAttention() {
    setFlagLoading(true);
    var token = localStorage.getItem("token");
    axios({
      url: apiUrl,
      method: "POST",
      data: {
        query: "\n          query CurrentTradeDetails {\n            me {\n              id\n              currentTrade {\n                id\n                hasAttentionAtCurrentTime\n                nextAttentionTime {\n                  isToday\n                  dayName\n                  fromHour\n                  fromMinute\n                }\n              }\n            }\n          }\n        "
      },
      headers: {
        Authorization: "JWT ".concat(token)
      }
    }).then(function (res) {
      var _res$data, _res$data$data, _res$data$data$me, _res$data2, _res$data2$data, _res$data2$data$me, _res$data2$data$me$cu, _user$currentTrade, _res$data3, _res$data3$data, _res$data3$data$me, _res$data3$data$me$cu;

      setFlagLoading(false);

      if (!flagLoading && (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$data = _res$data.data) === null || _res$data$data === void 0 ? void 0 : (_res$data$data$me = _res$data$data.me) === null || _res$data$data$me === void 0 ? void 0 : _res$data$data$me.currentTrade) && !(res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$data = _res$data2.data) === null || _res$data2$data === void 0 ? void 0 : (_res$data2$data$me = _res$data2$data.me) === null || _res$data2$data$me === void 0 ? void 0 : (_res$data2$data$me$cu = _res$data2$data$me.currentTrade) === null || _res$data2$data$me$cu === void 0 ? void 0 : _res$data2$data$me$cu.hasAttentionAtCurrentTime) && (user === null || user === void 0 ? void 0 : user.currentTrade) !== null) {
        setShowAlertOpening(true);
        return;
      }

      if (Number(user.currentTrade.minSpentAmount) > (totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.net.amount)) {
        setShowAlert(true);
      } else if (quantityAlert < Number(user === null || user === void 0 ? void 0 : (_user$currentTrade = user.currentTrade) === null || _user$currentTrade === void 0 ? void 0 : _user$currentTrade.minCheckoutItemsQuantity)) {
        setShowAlertAmount(true);
      } else {
        navigate(user ? "/checkout/" : "/login/");
      }

      return res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : (_res$data3$data = _res$data3.data) === null || _res$data3$data === void 0 ? void 0 : (_res$data3$data$me = _res$data3$data.me) === null || _res$data3$data$me === void 0 ? void 0 : (_res$data3$data$me$cu = _res$data3$data$me.currentTrade) === null || _res$data3$data$me$cu === void 0 ? void 0 : _res$data3$data$me$cu.hasAttentionAtCurrentTime;
    }) // eslint-disable-next-line no-console
    .catch(function (err) {
      return console.log(err);
    });
  };

  useEffect(function () {
    var timeout;

    if (hasSuccessVoucher) {
      timeout = setTimeout(function () {
        var _document$getElementB;

        (_document$getElementB = document.getElementById("sucessVoucher")) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.classList.add("cart__successVoucher--opacity");
        setHasSuccessVoucher(false);
      }, 3000);
      return function () {
        clearTimeout(timeout);
      };
    }
  }, [hasSuccessVoucher]);
  useEffect(function () {
    if (hour && hour > 12) {
      var countHour = 1;

      for (var i = 13; i < 24; i++) {
        if (hour === i) {
          if (hour === 22 || hour === 23) {
            setViewHour("".concat(countHour));
          } else {
            setViewHour("0".concat(countHour));
          }

          break;
        }

        countHour++;
      }
    }

    if (hour && hour >= 10 && hour <= 12) {
      setViewHour("".concat(hour));
    }

    if (hour && hour < 10 || !hour) {
      setViewHour("0".concat(hour));
    }

    return function () {
      setViewHour("0");
    };
  }, [hour]);
  useEffect(function () {
    setLoadingMutation(loaded);
  }, [loaded]);
  var hourAmPm = "";

  if (hour && hour <= 11) {
    hourAmPm = " am";
  } else {
    hourAmPm = " pm";
  }

  var promoTaxedPrice = discount && {
    gross: discount,
    net: discount
  };

  var missingVariants = function missingVariants() {
    return items.find(function (item) {
      return !item.variant || !item.totalPrice;
    });
  };

  var itemsQuantity = items === null || items === void 0 ? void 0 : items.reduce(function (quantity, item) {
    return quantity + item.quantity;
  }, 0);
  var finalTotalPrice = totalPrice && priceShipping.amount > 0 && !checkout.shippingMethod ? {
    gross: {
      amount: totalPrice.gross.amount + priceShipping.amount,
      currency: totalPrice.gross.currency
    },
    net: {
      amount: (totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.net.amount) + priceShipping.amount,
      currency: totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.net.currency
    }
  } : totalPrice;

  var handleUpdateItem = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(lineId, quantity, observation) {
      var _yield$updateItem, dataError;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              _context2.next = 3;
              return updateItem(lineId, quantity, observation);

            case 3:
              _yield$updateItem = _context2.sent;
              dataError = _yield$updateItem.dataError;

              if (dataError) {
                setErrors(dataError);
              }

              setLoading(false);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleUpdateItem(_x3, _x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleDeleteItem = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(lineId) {
      var _yield$removeItem, dataError;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setLoading(true);
              _context3.next = 3;
              return removeItem(lineId);

            case 3:
              _yield$removeItem = _context3.sent;
              dataError = _yield$removeItem.dataError;
              setTimeout(function () {
                if (dataError) {
                  setErrors(dataError);
                }

                setLoading(false);
              }, 800);

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleDeleteItem(_x6) {
      return _ref4.apply(this, arguments);
    };
  }();

  return React.createElement(React.Fragment, null, React.createElement(Overlay, {
    testingContext: "cartOverlay",
    context: overlay
  }, React.createElement(Online, null, React.createElement("div", {
    className: "cart"
  }, React.createElement("div", {
    className: "overlay__header"
  }, React.createElement(ReactSVG, {
    path: goBackImg,
    onClick: overlay.hide,
    className: "overlay__header-back"
  }), React.createElement("div", {
    className: "overlay__header-text"
  }, React.createElement(ReactSVG, {
    path: cartImg,
    className: "overlay__header__cart-icon"
  }), React.createElement("span", null, React.createElement(FormattedMessage, {
    id: "components.OverlayManager.Cart.Cart.1316031908",
    defaultMessage: "My bag,"
  })))), (items === null || items === void 0 ? void 0 : items.length) ? React.createElement(React.Fragment, null, missingVariants() ? React.createElement(Loader, {
    full: true
  }) : React.createElement(React.Fragment, null, React.createElement("div", {
    className: "cart__amount"
  }, React.createElement("p", {
    className: "cart__amount__items"
  }, React.createElement(FormattedMessage, {
    id: "components.OverlayManager.Cart.Cart.1074766822",
    defaultMessage: "{itemsQuantity,plural,one {Added <span>({itemsQuantity})</span>} other {Added <cta>({itemsQuantity})</cta>}}",
    description: "items quantity in cart",
    values: {
      itemsQuantity: itemsQuantity,
      span: function span() {
        for (var _len = arguments.length, chunks = new Array(_len), _key = 0; _key < _len; _key++) {
          chunks[_key] = arguments[_key];
        }

        return React.createElement("span", null, chunks);
      },
      cta: function cta() {
        for (var _len2 = arguments.length, chunks = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          chunks[_key2] = arguments[_key2];
        }

        return React.createElement("span", null, chunks);
      }
    }
  })), React.createElement("div", {
    className: "cart__emptyCart",
    onClick: function onClick() {
      setShowAlertDeleteCheckout(true);
    }
  }, React.createElement(ReactSVG, {
    path: emtpyCartImg
  }), React.createElement("p", null, React.createElement(FormattedMessage, {
    id: "components.OverlayManager.Cart.Cart.515981308",
    defaultMessage: "Empty bag"
  })))), React.createElement(ProductList, {
    lines: items,
    remove: handleDeleteItem,
    onDataChange: handleUpdateItem,
    hide: overlay.hide
  }), React.createElement("div", {
    className: "cart__footer"
  }, React.createElement("div", {
    className: "cart__footer__price"
  }, React.createElement("span", null, React.createElement(FormattedMessage, commonMessages.subtotal)), React.createElement("span", null, React.createElement(Money, {
    "data-test": "subtotalPrice",
    money: subtotalPrice === null || subtotalPrice === void 0 ? void 0 : subtotalPrice.net
  }))), React.createElement("div", {
    className: "cart__footer__price"
  }, React.createElement("span", null, intl.formatMessage(commonMessages.shipping)), React.createElement("span", null, React.createElement(Money, {
    "data-test": "priceShipping",
    money: priceShipping
  }))), promoTaxedPrice && (promoTaxedPrice === null || promoTaxedPrice === void 0 ? void 0 : promoTaxedPrice.net.amount) !== 0 && React.createElement("div", {
    className: "cart__footer__price"
  }, React.createElement("span", null, React.createElement(FormattedMessage, commonMessages.promoCode)), React.createElement("span", null, React.createElement(Money, {
    "data-test": "promoCodePrice",
    money: promoTaxedPrice === null || promoTaxedPrice === void 0 ? void 0 : promoTaxedPrice.net
  }))), React.createElement("div", {
    className: "cart__footer__price cart__footer__price--total"
  }, React.createElement("span", null, React.createElement(FormattedMessage, commonMessages.total)), React.createElement("span", null, React.createElement(Money, {
    "data-test": "totalPrice",
    money: finalTotalPrice === null || finalTotalPrice === void 0 ? void 0 : finalTotalPrice.net
  }))), React.createElement("div", {
    className: "cart__footer__button"
  }, React.createElement("span", {
    onClick: overlay.hide
  }, React.createElement(Button, {
    testingContext: "gotoContinueShopping",
    secondary: true
  }, React.createElement(FormattedMessage, {
    id: "components.OverlayManager.Cart.Cart.3657540412",
    defaultMessage: "continue shopping"
  })))), flagLoading ? React.createElement(S.Loader, null, React.createElement(Loader, null)) : React.createElement("div", {
    className: "buttonAnimationDesktop"
  }, React.createElement(animated.button, {
    className: window.outerWidth > 850 ? "buttonAnimationDesktop__button" : "buttonAnimationMovile__button",
    onClick: function onClick() {
      return refreshHasAttention();
    },
    style: scaleButton
  }, React.createElement("span", null, React.createElement(FormattedMessage, commonMessages.checkout))))))) : React.createElement(Empty, {
    overlayHide: overlay.hide
  }))), React.createElement(Offline, null, React.createElement("div", {
    className: "cart"
  }, React.createElement(OfflinePlaceholder, null)))), hasSuccessVoucher && React.createElement("div", {
    id: "sucessVoucher",
    className: "cart__successVoucher"
  }, React.createElement("p", null, React.createElement(FormattedMessage, {
    id: "components.OverlayManager.Cart.Cart.1483721968",
    defaultMessage: "Discount apply successfully"
  }))), (vouchersLoading && !(promoCodeDiscount === null || promoCodeDiscount === void 0 ? void 0 : promoCodeDiscount.voucherCode) || loadingPromoCode || loading || !loadingMutation) && React.createElement("div", {
    className: "cart__loader"
  }, React.createElement(Loader, {
    full: true
  })), showAlert && React.createElement(AlertCheckoutValue, {
    hideModal: function hideModal() {
      setShowAlert(false);
    },
    minSpent: user.currentTrade.minSpentAmount,
    currency: totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.net.currency
  }), showAlertAmount && React.createElement(AlertCheckoutAmount, {
    hideModal: function hideModal() {
      setShowAlertAmount(false);
    },
    minItems: user === null || user === void 0 ? void 0 : (_user$currentTrade2 = user.currentTrade) === null || _user$currentTrade2 === void 0 ? void 0 : _user$currentTrade2.minCheckoutItemsQuantity
  }), showAlertOpening && React.createElement(AlertBusinessOpening, {
    hideModal: function hideModal() {
      setShowAlertOpening(false);
    },
    hour: viewHour,
    minutes: dataAttention === null || dataAttention === void 0 ? void 0 : (_dataAttention$curren3 = dataAttention.currentTrade) === null || _dataAttention$curren3 === void 0 ? void 0 : (_dataAttention$curren4 = _dataAttention$curren3.nextAttentionTime) === null || _dataAttention$curren4 === void 0 ? void 0 : _dataAttention$curren4.fromMinute,
    dayName: dataAttention === null || dataAttention === void 0 ? void 0 : (_dataAttention$curren5 = dataAttention.currentTrade) === null || _dataAttention$curren5 === void 0 ? void 0 : (_dataAttention$curren6 = _dataAttention$curren5.nextAttentionTime) === null || _dataAttention$curren6 === void 0 ? void 0 : _dataAttention$curren6.dayName,
    hourAmPm: hourAmPm
  }), showAlertDeleteCheckout && React.createElement(AlertDeleteCheckout, {
    removeCheckout: deleteCheckout,
    hideModal: function hideModal() {
      setShowAlertDeleteCheckout(false);
    },
    loading: loaded
  }), showVouchersList && React.createElement(AlertVouchersAvailableToUser, {
    hideModal: function hideModal() {
      return setShowVouchersList(false);
    },
    homeEntry: false,
    vouchersAvailableToUser: vouchersData === null || vouchersData === void 0 ? void 0 : vouchersData.vouchersAvailableToUser,
    setInputPromoValue: setInputPromoValue
  }), (promoCodeErrors === null || promoCodeErrors === void 0 ? void 0 : promoCodeErrors.length) > 0 || (errors === null || errors === void 0 ? void 0 : errors.length) > 0 && React.createElement(AlertCheckoutErrors, {
    errors: (promoCodeErrors === null || promoCodeErrors === void 0 ? void 0 : promoCodeErrors.length) > 0 ? promoCodeErrors : (errors === null || errors === void 0 ? void 0 : errors.length) > 0 && errors,
    hideModal: function hideModal() {
      if ((promoCodeErrors === null || promoCodeErrors === void 0 ? void 0 : promoCodeErrors.length) > 0) {
        setPromoCodeErrors([]);
      }

      if ((errors === null || errors === void 0 ? void 0 : errors.length) > 0) {
        setErrors([]);
      }
    }
  }));
};

export default Cart;